<template>
  <div>
    <!-- Container-fluid starts-->
    <div class="container">
      <Breadcrumbs :title="$t('sidebar.abunliyim')" />
      <h4 class="mb-3">
        {{ $t('sidebar.abunliyim') }}
      </h4>
      <div class="row">
        <div class="col-lg-8">
          <div v-if="myPackage !== null && !showPackages">
            <div class="card">
              <div class="card-body">
                <div class="lead f-w-600">
                  {{ myPackage.pack.name }}
                </div>
                <div>{{ myPackage.pack.description }}</div>
                <div>
                  <strong>{{ $t('addOnPage.bitmTarixi') }} </strong>
                  <span>{{ $t('dashboardCompany.key', {moment: getMoment(myPackage.expirationTime)}) }}</span>
                </div>
                <br>
                <br>

                <table class="table table-sm">
                  <tr v-for=" l in myPackageLimits">
                    <td>{{ l.name }}</td>
                    <td class="text-right">
                      <div
                        v-if="l.total === -1"
                        class="text-success"
                      >
                        {{ $t('subscriptionPage.limitsiz') }}
                      </div>
                      <div
                        v-else-if="l.total === 0"
                        class="text-danger"
                      >
                        {{ $t('subscriptionPage.x') }}
                      </div>
                      <div v-else>
                        {{ l.left }} / {{ l.total }}
                      </div>
                    </td>
                  </tr>
                </table>
              </div>
              <hr>
              <div
                v-if="['ACTIVE','EXPIRED'].indexOf(myPackage.status)>-1 && profile!=='PROCUREMENT' "
                class="card-body"
              >
                <button
                  v-if="myPackage.card === null "
                  class="btn btn-primary"
                  @click.prevent="addCard"
                >
                  {{ $t('addOnPage.yenilnmNKartLavEt') }}
                </button>
                <div v-else>
                  <p>
                    {{
                      $t('addOnPage.abunlyinizTarixindAadaGstrilnKartVasitsilAvtomatik', {moment: getMoment(myPackage.expirationTime)})
                    }}
                  </p>

                  <button class="btn btn-lg btn-outline-dark">
                    <feather type="credit-card" />
                    {{ myPackage.card.pan }}
                  </button>
                  <button
                    class="btn btn-warning ml-3"
                    @click.prevent="addCard"
                  >
                    {{ $t('addOnPage.kartDyi') }}
                  </button>
                </div>
              </div>
              <hr>
              <div class="card-body">
                <button
                  v-if="profile!=='PROCUREMENT' "
                  class="btn btn-primary"
                  @click.prevent="showPackages=true"
                >
                  {{ $t('addOnPage.paketimiDyi') }}
                </button>

                <button
                  v-if="(myPackage.status==='ACTIVE' || myPackage.status==='EXPIRED') && profile!=='PROCUREMENT'"
                  class="btn btn-danger ml-1"
                  @click.prevent="cancelPackage"
                >
                  {{ $t('addOnPage.paketiLvEt') }}
                </button>

                <button
                  v-if="myPackage.status==='CANCELED' "
                  class="btn btn-success ml-1"
                  @click.prevent="reactivatePackage"
                >
                  {{ $t('addOnPage.paketiYenidnAktivldir') }}
                </button>

                <router-link
                  :to="{name: 'companyUserSectors' , query:{next: 'subscription'}}"
                  class="btn btn-outline-primary ml-1"
                >
                  {{ $t('companyUserSectors.faliyytSahlrim') }}
                </router-link>
              </div>
            </div>
          </div>


          <div v-else>
            <div class="card">
              <div class="card-body">
                <table class="table table-sm table-striped table-bordered">
                  <tr>
                    <td />
                    <td
                      v-for="p in packageList"
                      class="text-center"
                    >
                      <strong>{{ p.package.name }}</strong> <br>
                      <span>{{ p.package.description }}</span>
                    </td>
                  </tr>
                  <tr>
                    <td />
                    <td
                      v-for="p in packageList"
                      class="text-center"
                      style="white-space: nowrap"
                    >
                      <s>{{ $t('packagePeriodItem.azn', {oldPrice: p.package.oldPrice}) }}</s> <br>
                      <strong class="lead text-primary">{{
                        $t('offerExtrasView.azn', {price: p.package.price})
                      }}</strong>
                    </td>
                  </tr>
                  <tr
                    v-for="(f,k) in featureMap"
                    :key="k"
                  >
                    <td>{{ f }}</td>
                    <td
                      v-for="p in packageList"
                      class="text-center"
                    >
                      <div
                        v-if="featureCountMap[k][p.package.id] === -1"
                        class="text-success"
                      >
                        {{ $t('subscriptionPage.limitsiz') }}
                      </div>
                      <div
                        v-else-if="featureCountMap[k][p.package.id] === 0"
                        class="text-danger"
                      >
                        {{ $t('subscriptionPage.x') }}
                      </div>
                      <div v-else>
                        {{ featureCountMap[k][p.package.id] }}
                      </div>
                    </td>
                  </tr>

                  <tr>
                    <td />
                    <td
                      v-for="p in packageList"
                      class="text-center"
                      style="white-space: nowrap"
                    >
                      <s>{{ $t('packagePeriodItem.azn', {oldPrice: p.package.oldPrice}) }}</s> <br>
                      <strong class="lead text-primary">{{
                        $t('offerExtrasView.azn', {price: p.package.price})
                      }}</strong>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <button
                        v-if="myPackage!=null"
                        class="btn btn-sm btn-outline-primary"
                        @click.prevent="showPackages = false"
                      >
                        {{ $t('companyProfile.lvEt') }}
                      </button>
                    </td>
                    <td v-for="p in packageList">
                      <!--                      <div-->
                      <!--                        v-if="!trialUsed"-->
                      <!--                        class="text-primary text-center mb-3"-->
                      <!--                      >-->
                      <!--                        {{ p.package.trialDays }} gün pulsuz istifadə-->
                      <!--                      </div>-->

                      <button
                        class="btn btn-sm btn-primary"
                        @click.prevent="selectPackage(p)"
                      >
                        <span v-if="myPackage!=null && myPackage.pack.id === p.package.id">
                          {{ $t('addOnPage.mddtiDyi') }}
                        </span>
                        <span v-else>{{ $t('addOnPage.paketiAktivldir') }}</span>
                      </button>
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </div>

        <div
          v-if="company"
          class="col-lg-4"
        >
          <div class="card">
            <div class="card-body">
              <div class="media align-items-center">
                <img
                  class="rounded-circle user-image border mr-2"
                  :src="getPhoto(company.logo,'thumbnailCropped')"
                  alt=""
                  style="width: 60px"
                >
                <div class="about">
                  <div class="name f-w-600">
                    {{ company.name }} {{ getCompanyFormat(company.format) }}
                  </div>
                  <div class="status">
                    {{ company.taxId }}
                  </div>
                </div>
              </div>

              <p class="mt-2">
                {{
                  $t('dashboardActiveCompanyCard.sizHazrdaIrktind', {
                    name: company.name,
                    getCompanyFormat: getCompanyFormat(company.format)
                  })
                }}
                <strong> {{ getProfileName(profile) }} </strong> {{ $t('dashboardActiveCompanyCard.profilid') }}
                <strong>{{ position }}</strong>
                {{ $t('dashboardActiveCompanyCard.vzifsindFaliyytGstrirsiniz') }}
              </p>
            </div>
          </div>
          <div class="card">
            <div class="card-body">
              <div class=" f-w-600 mb-3">
                {{ $t('subscriptionPage.paketZrLimitlr') }}
              </div>
              <table class="table table-sm">
                <tr>
                  <td class="px-1">
                    3
                  </td>
                  <td>{{ $t('subscriptionPage.funksiyaZr3IstifadLimitiNzrdTutulmudur') }}</td>
                </tr>
                <tr>
                  <td class="px-1">
                    3/4
                  </td>
                  <td>{{ $t('subscriptionPage.funksiyaZrVerilmi4IstifadLimitindn3IstifadEdilmyib') }}</td>
                </tr>
                <tr>
                  <td class="px-1">
                    -/3
                  </td>
                  <td>{{ $t('subscriptionPage.funksiyaZrVerilmi3IstifadLimitindnHamsIstifadEdili') }}</td>
                </tr>
                <tr>
                  <td class="text-danger px-1">
                    {{ $t('subscriptionPage.x') }}
                  </td>
                  <td>{{ $t('subscriptionPage.buFunksiyaHazrkiPaketGrDeaktivdir') }}</td>
                </tr>
                <tr>
                  <td class="text-success px-1">
                    {{ $t('subscriptionPage.limitsiz') }}
                  </td>
                  <td>{{ $t('subscriptionPage.funksiyadanLimitsizSaydaIstifadEdBilrsiz') }}</td>
                </tr>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Container-fluid Ends-->

    <b-modal
      id="modal-periods"
      ref="periods"
      centered
      :title="$t('addOnPage.paketSeimi')"
      :ok-disabled="selectedPeriod === null || packageTerms<1"
      class="theme-modal"
      @ok="activatePackage(selectedPeriod)"
    >
      <div v-if="selectedPackage">
        <h3>{{ selectedPackage.package.name }}</h3>
        <p>{{ selectedPackage.package.description }}</p>


        <div
          v-for="p in selectedPackage.periods"
          :key="p.id"
          @click.prevent="selectedPeriod = p"
        >
          <PackagePeriodItem
            :period="p"
            :pack="selectedPackage.package"
            :selected=" selectedPeriod && p.id === selectedPeriod.id"
            :trial-used="trialUsed"
          />
        </div>

        <div v-if="selectedPeriod">
          <div class="checkbox checkbox-success mb-3">
            <b-form-checkbox
              v-model="packageTerms"
              value="1"
              required
            >
              <router-link
                target="_blank"
                :to="{path: '/dashboard/page/package_terms'}"
              >
                {{ $t('addOnPage.dniRtVQaydalarnQbulEdirm') }}
              </router-link>
            </b-form-checkbox>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
import {mapState} from "vuex";
import {
  activatePackage,
  cancelPackage,
  getMyPackage,
  getPackages,
  reactivatePackage,
} from "/src/repositories/GeneralDataRepository";
import {mediaBase, paymentDomain} from "@/repositories/Repository";
import {buildLongId, getCompanyFormat, getPhoto, getProfileName} from "@/repositories/Utils";
import PackagePeriodItem from "@/pages/scc/package/PackagePeriodItem.vue";
import moment from "moment/moment";


export default {
  components: {PackagePeriodItem},
  data() {
    return {
      mediaBase: mediaBase,
      paymentDomain: paymentDomain,
      packageList: [],
      myPackage: null,
      myPackageLimits: [],
      showPackages: false,
      trialUsed: true,
      selectedPackage: null,
      selectedPeriod: null,
      packageTerms: 0
    }
  },
  computed: {
    ...mapState({
      token: state => state.auth.token,
      user: state => state.auth.user,
      company: state => state.auth.company,
      sessionType: state => state.auth.sessionType,
      profile: state => state.auth.profile,
      position: state => state.auth.position
    }),

    featureCountMap() {
      let map = {};
      this.packageList.forEach(p => {
        p.features.forEach(f => {
          if (!map[f.keyword]) {
            map[f.keyword] = {};
          }
          map[f.keyword][p.package.id] = f.count;
        })
      })
      return map;
    },
    featureMap() {
      let map = {};
      this.packageList.forEach(p => {
        p.features.forEach(f => {
          if (!map[f.keyword]) {
            map[f.keyword] = f.name;
          }
        })
      })
      return map;
    }

  },
  mounted() {

    this.getOffers();

  },
  methods: {
    getMoment(time) {
      moment.locale(this.$i18n.locale);
      return moment(new Date(time)).format('DD MMM YYYY HH:mm')
    },
    getPhoto(path, size, defaultPhoto) {
      return getPhoto(path, size, defaultPhoto);
    },
    getProfileName(keyword) {
      return getProfileName(keyword,this.i18n);
    },
    getCompanyFormat(keyword) {
      return getCompanyFormat(keyword, this.$i18n.locale);
    },

    buildLongId(id) {
      return buildLongId(id, 5);
    },
    getOffers() {
      getMyPackage(this.token, this.$i18n.locale).then(data => {
        if (data.code === 200) {
          this.myPackage = data.package;
          this.myPackageLimits = data.limits;
        } else if (data.code === 404) {
          this.showPackages = true;
        } else if (data.code === 406) {
          this.$router.push('/');
        } else {
          this.$swal({
            title: `Error ${data.code}`,
            text: `${data.message}`,
            icon: 'error'
          }).then(() => {
            window.location.reload();
          })
        }
      });
      getPackages(this.token, 'package').then(data => {
        if (data.code === 200) {
          this.packageList = data.packages;
          this.trialUsed = data.trialUsed;
        } else {
          this.$swal({
            title: `Error ${data.code}`,
            text: `${data.message}`,
            icon: 'error'
          })
        }
      })
    },

    activatePackage(period) {
      console.log(period)
      if (period != null) {

        if (this.packageTerms > 0) {

          activatePackage(this.token, period).then(data => {
            if (data.code === 200) {
              window.location.href = this.paymentDomain+'/invoice.php?invoice=' + data.id
            } else {
              this.$swal({
                title: `Error ${data.code}`,
                text: `${data.message}`,
                icon: 'error'
              })
            }
          });
        } else {
          this.$refs.periods.show();
          this.$swal({
            title: this.$t("generalModal.warningTitle"),
            text: this.$t("odnsSrtQydlrQbl"),
            icon: 'error'
          });

        }
      }

    },
    cancelPackage() {

      if (confirm(this.$t("szAbnlyDyndrdqSnraSechdiyiniz"))) {
        cancelPackage(this.token).then(data => {
          if (data.code === 200) {
            this.$swal({
              title: this.$t("generalModal.successTitle"),
              text: this.$t("abunlynzDyndrld"),
              icon: 'success'
            })
            this.getOffers();
          } else {
            this.$swal({
              title: `Error ${data.code}`,
              text: `${data.message}`,
              icon: 'error'
            })
          }
        });
      }
    }, reactivatePackage() {

      if (confirm(this.$t("abunlynzDvmEtdrmkIs"))) {
        reactivatePackage(this.token).then(data => {
          if (data.code === 200) {
            this.$swal({
              title: this.$t("generalModal.successTitle"),
              text: this.$t("abnlynzDvmEtdrl"),
              icon: 'success'
            })
            this.getOffers();
          } else {
            this.$swal({
              title: `Error ${data.code}`,
              text: `${data.message}`,
              icon: 'error'
            })
          }
        });
      }
    },

    addCard() {
      window.location.href = this.paymentDomain + '/saveCard.php?userPackageId=' + this.myPackage.id
    },

    selectPackage(pack) {
      this.selectedPackage = pack;
      this.selectedPeriod = null;
      this.packageTerms = 0;
      this.$refs.periods.show();
    },
  }
}
</script>
<style>
div.review canvas {
  position: relative !important;
}

div.review input {
  z-index: 1;
  display: inline-block;
}
</style>
